import { Form, FormFeedback, FormGroup, Input, Label } from 'reactstrap';
import {BucketImageDocType} from "../../../models/config/BucketImageDocType";
import React, {forwardRef, useImperativeHandle, useState} from "react";
import {twMerge} from "tailwind-merge";

export type BucketConfigFormRefHandle = {
    submit: () => BucketImageDocType | undefined;
};

export type BucketConfigFormProps = {
    disabledKeyField?: boolean;
    defaultValues?: BucketImageDocType;
    className?: string;
};

export const BucketConfigForm = forwardRef<
    BucketConfigFormRefHandle,
    BucketConfigFormProps
>((props, ref) => {
    const { disabledKeyField, defaultValues, className } = props;

    const [formValues, setFormValues] = useState<
        Partial<BucketImageDocType>
    >({ ...defaultValues });
    const [errors, setErrors] = useState<Record<keyof BucketImageDocType, string>>(
        {} as BucketImageDocType
    );

    const handleFormValueChange = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        const key = event.currentTarget.name;
        const value = event.currentTarget.value;

        setFormValues({ ...formValues, [key]: value });
    };

    const submitForm = () => {
        const errors: [keyof BucketImageDocType, string][] = [];
        if (!formValues.image_doc_type) {
            errors.push(['image_doc_type', 'กรุณากรอก Image Doc Type']);
        }
        if (!formValues.bucket_id) {
            errors.push(['bucket_id', 'กรุณากรอก Bucket ID']);
        }

        if (errors.length > 0) {
            setErrors(prevState => ({
                ...prevState,
                // @ts-ignore
                ...Object.fromEntries(errors)
            }));

            return undefined;
        }

        return {...formValues} as BucketImageDocType;
    };

    useImperativeHandle(
        ref,
        () => ({
            submit: submitForm
        }),
        [submitForm]
    );
    
    return (
        <Form className={twMerge('tw-flex tw-flex-col', className)}>
            <FormGroup>
                <Label for="image_doc_type">Image Doc Type</Label>
                <Input
                    disabled={disabledKeyField}
                    invalid={!!errors.image_doc_type}
                    id="image_doc_type"
                    type="text"
                    name="image_doc_type"
                    value={formValues.image_doc_type}
                    onChange={
                        !disabledKeyField ? handleFormValueChange : undefined
                    }
                />
                <FormFeedback>{errors.image_doc_type}</FormFeedback>
            </FormGroup>
            <FormGroup>
                <Label for="bucket_id">Bucket ID</Label>
                <Input
                    invalid={!!errors.bucket_id}
                    id="bucket_id"
                    type="text"
                    name="bucket_id"
                    value={formValues.bucket_id}
                    onChange={handleFormValueChange}
                />
                <FormFeedback>{errors.bucket_id}</FormFeedback>
            </FormGroup>
        </Form>
    );
});

BucketConfigForm.displayName = 'BucketConfigForm';